import { SxProps, Theme } from '@mui/material'

const styles = {
  modalBody: {
    paddingTop: 2
  } as SxProps<Theme>,

  errorMessage: {
    marginBottom: 2
  } as SxProps<Theme>,

  itemsList: {
    marginTop: 2,
    paddingLeft: 2
  } as SxProps<Theme>,

  itemText: {
    marginBottom: 0.5
  } as SxProps<Theme>
}

export default styles
